import api from './client';
import { Medicine, CreateMedicineDto } from '../types/medicines';

export const medicinesApi = {
  getAll: async (): Promise<Medicine[]> => {
    const response = await api.get<Medicine[]>('/medicines');
    return response.data;
  },

  getById: async (id: number): Promise<Medicine> => {
    const response = await api.get<Medicine>(`/medicines/${id}`);
    return response.data;
  },

  create: async (data: CreateMedicineDto): Promise<Medicine> => {
    const response = await api.post<Medicine>('/medicines', data);
    return response.data;
  },

  update: async (id: number, data: Partial<CreateMedicineDto>): Promise<Medicine> => {
    const response = await api.put<Medicine>(`/medicines/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete<void>(`/medicines/${id}`);
  },

  search: async (query: string): Promise<Medicine[]> => {
    const response = await api.get<Medicine[]>(`/medicines/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  bulkCreate: async (medicines: CreateMedicineDto[]): Promise<Medicine[]> => {
    const response = await api.post<Medicine[]>('/medicines/bulk', { medicines });
    return response.data;
  },
}; 